import React, { useEffect, useState } from 'react';

import { BaseCustomComponentVideo } from '../add-element';
import * as ButtonsStyled from '../common-menu-item.styles';
import { Menu } from '../menu/menu';

export type PlaybackRates = 0.5 | 0.75 | 1 | 1.25 | 1.5 | 2;
export const playbackRatesDefaultOptions: PlaybackRates[] = [
  0.5, 0.75, 1, 1.25, 1.5, 2,
];
const DEFAULT_PLAYBACK_RATE: PlaybackRates = 1;

type Props = BaseCustomComponentVideo & {
  playbackRates?: PlaybackRates[];
};
export const PlaybackRatesButton: React.FC<Props> = ({
  player,
  playbackRates: playbackRatesOptions = playbackRatesDefaultOptions,
}) => {
  const [playbackRate, setPlaybackRate] = useState(
    player.playbackRate() || DEFAULT_PLAYBACK_RATE
  );

  useEffect(() => {
    player.on('ratechange', () => {
      setPlaybackRate(player.playbackRate() || DEFAULT_PLAYBACK_RATE);
    });
    return () => {
      player.off('ratechange');
    };
  }, [player]);

  const handleOnClick = (option: PlaybackRates): void => {
    player.playbackRate(option);
  };

  if (playbackRatesOptions.length === 0) {
    return null;
  }

  return (
    <Menu player={player} button={() => <>{playbackRate} x</>}>
      {(hideMenu) =>
        playbackRatesOptions.map((option) => (
          <ButtonsStyled.ItemButton
            key={option}
            $selected={playbackRate === option}
            onClick={() => {
              handleOnClick(option);
              hideMenu();
            }}
          >
            {option} x
          </ButtonsStyled.ItemButton>
        ))
      }
    </Menu>
  );
};
